// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#topBar[data-v-9786ec9e] {\n  background-color: var(--primaryColor, #A82339);\n  font-size: 14px;\n  -webkit-text-decoration: none solid rgb(51, 51, 51);\n          text-decoration: none solid rgb(51, 51, 51);\n  color: #ffffff;\n  height: 62px;\n  padding: 0 1rem;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  margin: 0;\n  z-index: 101;\n}", ""]);
// Exports
module.exports = exports;
